import { DocumentRequestUpload } from "./CustomerDocumentsUpload";

export default function AssetDocumentsUpload() {
  return <DocumentRequestUpload entityType="asset" />;
}
